import {Component} from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import Badge from 'react-bootstrap/lib/Badge';
import request from 'request-promise-native';
import LoadingModal from "../modals/LoadingModal";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import YesNoDialog from "../modals/YesNoDialog";
import SuccessDialog from "../modals/SuccessDialog";
import FailedDialog from "../modals/FailedDialog";
import FormDialog from "../modals/FormDialog";
import Alert from "react-bootstrap/lib/Alert";
import AzureTable from "../AzureTable";

const GET_DEVICE_LIST = "https://flexa-base.azurewebsites.net/api/NGetList";
const DELETE_DEVICE = "https://flexa-base.azurewebsites.net/api/";
const UNASSIGN_DEVICE = "https://flexa-base.azurewebsites.net/api/UnassignDevice";
const ADD_DEVICE = "https://flexa-base.azurewebsites.net/api/CreateProducedDevice";
const ADD_DEVICES = "https://flexa-base.azurewebsites.net/api/CreateProducedDevices";
const ADD_MOBILE_DEVICE = "https://flexa-base.azurewebsites.net/api/CreateProducedMobileDevice";

const MAC_REGEX = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

class ListDevicesTab extends Component {

    constructor(props) {
        /*
            Props:
             - access_code
             - logout
        */
        super(props);

        this.state = {
            addDeviceOpen: false,
            addingDevice: false,
            addDeviceSuccess: null,
            addDeviceFailed: null,

            addMobileDeviceOpen: false,
            addingMobileDevice: false,
            addMobileDeviceSuccess: null,
            addMobileDeviceFailed: null,
            addMobileDeviceType: null,

            addDevicesOpen: false,
            addingDevices: false,
            addDevicesSuccess: null,
            addDevicesFailed: null,

            deleteDeviceOpen: false,
            deleteDevice: null,
            deletingDevice: false,

            unassignDeviceOpen: false,
            unassignDevice: null,
            unassigningDevice: false,
            unassignDeviceSuccess: false,
            unassignDeviceFailed: false,

            loading: true,

            /*devices: null,

            searchButton: true,

            tableLoading: false,
            pages: 1,
            page: 0*/
        };

        //this.pageCache = null;

        //this.currentSearch = null;
        //this.loadDevices.bind(this)();
    }

    /*async fetchData(state,instance) {
        console.log("State: ",state);
        console.log("Instance: ",instance);

        const sort = state.sorted[0];

        console.log("Sort:",sort);

        if(sort.desc!==this.currentOrderDesc) {
            this.currentOrderDesc = sort.desc;
            this.pageCache = null;
            this.setState({
                page: 0
            });
        }

        this.setState({
            tableLoading: true
        });

        if(this.pageCache==null) {
            const options = {
                method: 'POST',
                uri: GET_DEVICE_LIST,
                body: {
                    access_code: this.props.access_code,
                    descending: sort.desc,
                    search: this.currentSearch
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            if(response.statusCode!=200) {
                console.log('Logging out!');
                this.props.logout();
                return;
            }

            this.props.turnOffLoading();

            this.pageCache = [];
            this.pageCache[0] = response.body;

            if(response.body[0]==null || response.body[0].last) {
                this.setState({
                    devices: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 1
                });
            } else {
                this.setState({
                    devices: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 2
                });
            }

            console.log("Cards request success");
        } else {
            if(this.pageCache[state.page]!=null) {
                this.setState({
                    devices: this.pageCache[state.page],
                    tableLoading: false,
                    loading: false
                });
            } else {

                let lastMacInt = null;

                if(this.pageCache[state.page-1]!=null) {
                    const page = this.pageCache[state.page-1];
                    console.log("Page: "+(state.page-1), page);
                    lastMacInt = page[9].macInt;
                }
                console.log("LastMAC INT: "+lastMacInt);

                const options = {
                    method: 'POST',
                    uri: GET_DEVICE_LIST,
                    body: {
                        access_code: this.props.access_code,
                        lastMacInt: lastMacInt,
                        descending: sort.desc,
                        search: this.currentSearch
                    },
                    json: true,
                    resolveWithFullResponse: true,
                    simple: false
                };

                const response = await request(options);

                if(response.statusCode!=200) {
                    console.log('Logging out!');
                    this.props.logout();
                    return;
                }

                this.pageCache[state.page] = response.body;

                if(response.body[0]==null || response.body[0].last) {
                    this.setState({
                        devices: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+1
                    });
                } else {
                    this.setState({
                        devices: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+2
                    });
                }


                console.log("Cards request success");
            }
        }

    }*/

    /*async deleteDevice(device) {
        const options = {
            method: 'POST',
            uri: DELETE_DEVICE,
            body: {
                access_code: this.props.access_code,
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);
    }*/

    async unassignDevice(device) {

        const options = {
            method: 'POST',
            uri: UNASSIGN_DEVICE,
            body: {
                access_code: this.props.access_code,
                device: device.id
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            //device.registered = false;
            this.tableRef.resetTable();
            this.setState({
                unassignDeviceSuccess: true,
                //devices: this.state.devices,
                unassigningDevice: false
            });
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
            return;
        }

        this.setState({
            unassignDeviceFailed: true,
            unassigningDevice: false
        });

    }

    /*resetTable() {
        this.pageCache = null;
        this.setState({
            page: 0
        },() => {
            this.fetchData.bind(this)({
                sorted: [
                    {
                        desc: this.currentOrderDesc
                    }
                ]
            },null);
        });
    }*/

    async addDevice(mac) {

        this.setState({
            addingDevice: true,
            addDeviceSuccess: null,
            addDeviceFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_DEVICE,
            body: {
                access_code: this.props.access_code,
                mac: mac
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addDeviceSuccess: response.body,
                addingDevice: false,
            });
            this.tableRef.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addDeviceFailed: response.body,
            addingDevice: false,
        });

    }

    async addMobileDevice(deviceType, imei) {

        this.setState({
            addingMobileDevice: true,
            addMobileDeviceSuccess: null,
            addMobileDeviceFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_MOBILE_DEVICE,
            body: deviceType==="imei" ? {
                access_code: this.props.access_code,
                imei,
                deviceType
            } : {
                access_code: this.props.access_code,
                deviceType
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addMobileDeviceSuccess: response.body,
                addingMobileDevice: false,
            });
            this.tableRef.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addMobileDeviceFailed: response.body,
            addingMobileDevice: false,
        });

    }

    async addDevices(macLower, macUpper) {

        this.setState({
            addingDevices: true,
            addDevicesSuccess: null,
            addDevicesFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_DEVICES,
            body: {
                access_code: this.props.access_code,
                macLower,
                macUpper
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addDevicesSuccess: (
                    <div>
                        {response.body.msg} Download csv file <a href={response.body.url}>here</a>!
                     </div>
                ),
                addingDevices: false,
            });
            this.tableRef.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addDevicesFailed: response.body,
            addingDevices: false,
        });

    }

    render() {
        if(!this.props.open) return null;
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-apps"></i> Device List <a href="javascript:void(0);" style={{
                                fontSize: "15px"
                            }} onClick={() => {
                                this.tableRef.resetTable()
                            }}><i className="fa fa-sync"/></a></h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-success" onClick = {() => this.setState({addMobileDeviceOpen: true, addMobileDeviceType: null})}>
                                    <i className="mdi mdi-plus font-16"></i>Add External Device
                                </button>
                                <button className="btn btn-primary ml-2" onClick = {() => this.setState({addDeviceOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Device
                                </button>
                                <button className="btn btn-cyan ml-2" onClick = {() => this.setState({addDevicesOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add More Devices
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <YesNoDialog open={this.state.deleteDeviceOpen}
                             title="Delete device"
                             text={(
                                <div>
                                    Do you really want to delete this device?<br/>
                                    <b>Registration ID:</b> {this.state.deleteDevice ? this.state.deleteDevice.id : ""}<br/>
                                    <b>MAC Address:</b> {this.state.deleteDevice ? this.state.deleteDevice.mac : ""}
                                </div>
                             )}
                             onYes={() => {
                                 this.deleteDevice.bind(this)(this.state.deleteDevice);
                                 this.setState({
                                     deleteDeviceOpen: false,
                                     deleteDevice: null,
                                     deletingDevice: true
                                 });
                             }}
                             onNo={() => {
                                 this.setState({
                                     deleteDeviceOpen: false,
                                     deleteDevice: null
                                 });
                             }}
                            />
                <LoadingModal open={this.state.deletingDevice}
                                title="Deleting device..."
                />

                <YesNoDialog open={this.state.unassignDeviceOpen}
                             title="Unassign device"
                             text={(
                                 <div>
                                     Do you really want to unassign this device?<br/>
                                     <b>Registration ID:</b> {this.state.unassignDevice ? this.state.unassignDevice.id : ""}<br/>
                                     <b>MAC Address:</b> {this.state.unassignDevice ? this.state.unassignDevice.mac : ""}<br/>
                                     <b>Assigned to URL:</b> {this.state.unassignDevice ? this.state.unassignDevice.url : ""}<br/>
                                 </div>
                             )}
                             onYes={() => {
                                 this.unassignDevice.bind(this)(this.state.unassignDevice);
                                 this.setState({
                                     unassignDeviceOpen: false,
                                     unassignDevice: null,
                                     unassigningDevice: true
                                 });
                             }}
                             onNo={() => {
                                 this.setState({
                                     unassignDeviceOpen: false,
                                     unassignDevice: null
                                 });
                             }}
                />
                <LoadingModal open={this.state.unassigningDevice}
                              title="Unassigning device..."
                />
                <FailedDialog open={this.state.unassignDeviceFailed}
                              onClose={() => this.setState({unassignDeviceFailed:false})}
                              title="Unassign failed"
                              text="Device cannot be unassigned!"/>
                <SuccessDialog open={this.state.unassignDeviceSuccess}
                               onClose={() => this.setState({unassignDeviceSuccess:false})}
                               title="Unassign success"
                               text="Device has been unassigned successfully!"/>

                <FormDialog open={this.state.addDeviceOpen}
                            onClose={() => {
                                this.setState({
                                    addDeviceOpen:false,
                                    addDeviceFailed: false,
                                    addDeviceSuccess: false
                                })
                            }}
                            titleText="Add device"
                            submitText="Add device"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return MAC_REGEX.test(value) ? null : "Not a valid mac address";
                                    },
                                    name: "Mac Address",
                                    type: "text",
                                    placeholder: "Enter mac address"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const mac = obj["Mac Address"].replace(new RegExp("-",'g'),":");
                                console.log("Adding device with MAC: "+mac);
                                this.addDevice.bind(this)(mac);
                            }}
                            notification={this.state.addDeviceSuccess ? (<Alert bsStyle="success"><strong>{this.state.addDeviceSuccess}</strong></Alert>) : this.state.addDeviceFailed ? (<Alert bsStyle="danger"><strong>{this.state.addDeviceFailed}</strong></Alert>) : ""}
                            loading={this.state.addingDevice}/>

                <FormDialog open={this.state.addMobileDeviceOpen}
                            onClose={() => {
                                this.setState({
                                    addMobileDeviceOpen:false,
                                    addMobileDeviceFailed: false,
                                    addMobileDeviceSuccess: false
                                })
                            }}
                            titleText="Add external device"
                            submitText="Add external device"
                            inputs={[
                                this.state.addMobileDeviceType==="imei" || this.state.addMobileDeviceType==null ? {
                                    onValidate: (value) => {
                                        return !isNaN(parseInt(value)) && value.length===15 ? null : "Not a valid imei";
                                    },
                                    name: "Imei",
                                    type: "text",
                                    placeholder: "Enter device's imei"
                                } : null,
                                {
                                    onChange: (val) => {
                                        this.setState({
                                            addMobileDeviceType: val
                                        });
                                    },
                                    onValidate: () => null,
                                    type: "select",
                                    name: "Device type",
                                    options: [
                                        {
                                            name: "IMEI Device",
                                            value: "imei"
                                        },
                                        {
                                            name: "Raspberry PI",
                                            value: "raspi"
                                        },
                                        {
                                            name: "Android Device",
                                            value: "andro"
                                        }
                                    ],
                                    value_key: "value",
                                    display_name_key: "name"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const deviceType = obj["Device type"];
                                const imei = obj["Imei"];
                                console.log("Adding device "+deviceType+" with imei: "+imei);
                                this.addMobileDevice.bind(this)(deviceType,imei);
                            }}
                            notification={this.state.addMobileDeviceSuccess ? (<Alert bsStyle="success"><strong>{this.state.addMobileDeviceSuccess}</strong></Alert>) : this.state.addMobileDeviceFailed ? (<Alert bsStyle="danger"><strong>{this.state.addMobileDeviceFailed}</strong></Alert>) : ""}
                            loading={this.state.addingMobileDevice}/>

                <FormDialog open={this.state.addDevicesOpen}
                            onClose={() => {
                                this.setState({
                                    addDevicesOpen:false,
                                    addDevicesFailed: false,
                                    addDevicesSuccess: false
                                })
                            }}
                            titleText="Add more devices"
                            submitText="Add devices"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return MAC_REGEX.test(value) ? null : "Not a valid mac address";
                                    },
                                    name: "Lower Mac Address",
                                    type: "text",
                                    placeholder: "Enter lower mac address"
                                },
                                {
                                    onValidate: (value) => {
                                        return MAC_REGEX.test(value) ? null : "Not a valid mac address";
                                    },
                                    name: "Upper Mac Address",
                                    type: "text",
                                    placeholder: "Enter upper mac address"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const lowerMac = obj["Lower Mac Address"].replace(new RegExp("-",'g'),"").replace(new RegExp(":",'g'),"");
                                const upperMac = obj["Upper Mac Address"].replace(new RegExp("-",'g'),"").replace(new RegExp(":",'g'),"");
                                const lowerMacInt = parseInt(lowerMac, 16);
                                const upperMacInt = parseInt(upperMac, 16);
                                console.log("Adding devices with MAC L: "+lowerMac+" MAC U: "+upperMac);
                                this.addDevices.bind(this)(lowerMacInt,upperMacInt);
                            }}
                            notification={this.state.addDevicesSuccess ? (<Alert bsStyle="success"><strong>{this.state.addDevicesSuccess}</strong></Alert>) : this.state.addDevicesFailed ? (<Alert bsStyle="danger"><strong>{this.state.addDevicesFailed}</strong></Alert>) : ""}
                            loading={this.state.addingDevices}/>


                <div className="container-fluid">
                    <AzureTable
                        logout={this.props.logout}
                        access_code={this.props.access_code}
                        onLoad={() => {
                            this.setState({
                                loading: false
                            });
                        }}
                        tableRef={(ref) => {
                            this.tableRef = ref;
                        }}
                        functionUrl={GET_DEVICE_LIST}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        SubComponent={(row) => {
                            if(!row.original.registered) return null;
                            let date;
                            date = new Date(row.original.lastConnectionTimestamp);

                            const data = [
                                {
                                    name: "Assigned by",
                                    value: row.original.registrator
                                },
                                {
                                    name: "Assigned to URL",
                                    value: row.original.url
                                },
                                {
                                    name: "Last request time",
                                    value: row.original.lastConnectionTimestamp==null ? (<Badge>Never</Badge>) : date.toLocaleString(),
                                }
                            ];

                            if(row.original.DeviceInfo!=null) for(let field in row.original.DeviceInfo) {
                                data.push({
                                    name: field,
                                    value: row.original.DeviceInfo[field]
                                })
                            }

                            return (
                                <div className="mx-4 my-4">
                                        <ReactTable
                                            showPagination={false}
                                            sortable={false}
                                            filterable={false}
                                            pageSize={data.length}
                                            data={data}
                                            columns={[
                                                {
                                                    Header:"Device information",
                                                    accessor: "name",
                                                    maxWidth: 300,
                                                },
                                                {
                                                    accessor: "value"
                                                }
                                            ]}
                                        />
                                    <Button className="float-right mt-4" bsStyle="danger" onClick={() => {
                                        this.setState({
                                            unassignDeviceOpen: true,
                                            unassignDevice: row.original
                                        });
                                    }}>
                                        Unassign
                                    </Button>
                                </div>
                            );
                        }}
                        /*getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete' && column.Header!=="") return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addDeviceOpen: true,
                                        editDevice: rowInfo.original
                                    });
                                }
                            };
                            return {};
                        }}*/
                        columns={[
                            {
                                Header: "Registration ID",
                                accessor: "id",
                                sortable: false,
                                filterable: true
                            },
                            {
                                Header: "Identifier",
                                accessor: "mac",
                                Cell: (row) => {
                                    if(row.original.mac.startsWith("@")) {
                                        return (<div><Badge>IMEI</Badge> {row.original.mac}</div>);
                                    } else if(row.original.mac.startsWith("$")) {
                                        return (<div><Badge>Raspberry</Badge> {row.original.mac}</div>);
                                    } else if(row.original.mac.startsWith("&")) {
                                        return (<div><Badge>Android</Badge> {row.original.mac}</div>);
                                    } else {
                                        return (<div><Badge>Device MAC</Badge> {row.original.mac}</div>);
                                    }
                                },
                                filterable: true
                            },
                            {
                                Header: "Registered",
                                accessor: "registered",
                                width: 100,
                                Expander: (row) => {
                                    if(row.original.registered) {
                                        return (
                                            <div>
                                                <Badge><i className="mdi mdi-check"/></Badge> <Badge>Info {row.isExpanded ? (<i className="fa fa-arrow-up"/>) : (<i className="fa fa-arrow-down"/>)}</Badge>
                                            </div>
                                        );
                                    } else {
                                        return (<Badge><i className="mdi mdi-close"/></Badge>);
                                    }
                                },
                                sortable: false,
                                expander: true
                            }/*,
                            {
                                Header: "Delete",
                                Cell: row => (
                                    <OverlayTrigger placement="top" overlay={(
                                        <Tooltip id="tooltip">
                                            <strong>Delete device!</strong>
                                        </Tooltip>
                                    )}>
                                        <a href="#" onClick={() => {
                                            this.setState({
                                                deleteDeviceOpen: true,
                                                deleteDevice: row.original
                                            })
                                            console.log(row.original);
                                        }}><i className="fa fa-trash"></i></a>
                                    </OverlayTrigger>
                                ),
                                sortable: false
                            }*/
                        ]}
                        defaultSorted={[
                            {
                                id: "mac",
                                desc: false
                            }
                        ]}
                        defaultPageSize={10}
                        pageSize={10}
                        className="-striped -highlight"
                    />
                </div>
            </div>
        );
    }
}

export default ListDevicesTab;